export const statusType = (type) => {
    if (type === 'awaiting_approval') {
        return 'Awaiting Approval'
    } else if (type === 'live') {
        return 'Live'
    } else if (type === 'completed') {
        return 'Completed';
    }
}
